import React, { forwardRef } from 'react'
import clsx from 'clsx'
import { List as ListStyles } from '@airbus/elements/elements'
import { createUseStyles } from '../../lib/styling'
import { CommonProps, PolymorphicPropsWithRef, PolymorphicRef } from '../helperTypes'

const useStyles = createUseStyles(ListStyles, 'list')

export type ListProps<C extends React.ElementType> = PolymorphicPropsWithRef<C, {}>

// type annotation for strong typing of polymorphic ref
type PolymorphicList = <C extends React.ElementType = 'ul'>(
  props: ListProps<C> & CommonProps,
) => React.ReactElement | null

export const List: PolymorphicList = forwardRef(
  <C extends React.ElementType>(props: ListProps<C>, ref?: PolymorphicRef<C>) => {
    const { component, className, children, ...rest } = props
    const classes = useStyles()
    let ComponentProp = component || 'ul'
    return (
      <ComponentProp ref={ref} className={clsx(className, classes.root)} {...rest}>
        {children}
      </ComponentProp>
    )
  },
)

export default List
